<template>
  <sc-page-base :loading="loading">
    <div v-if="appDetails" class="columns margin-logo">
      <div class="column is-10">
        <h1 class="title page-base__title has-text-primary">
          Instalando integração com {{ appDetails.app_name }}
        </h1>
      </div>
      <div class="column is-2">
        <img :src="appDetails.img_url" v-if="appDetails.img_url" class="img-client" />
      </div>
    </div>

    <div class="columns">
      <div class="column is-12">
        <sc-steps v-if="steps" v-model="activeStep" size="is-medium" :has-navigation="false">

          <sc-step-item
            v-for="(step, index) in steps"
            :key="index"
            :label="step.title"
            :step="index + 1"
            :clickable="false">

            <sc-form autocomplete="off">
              <template slot="fields" slot-scope="{ fields }">
                <component :is="step.component" :fieldGroupName="step.fieldGroupName" :fieldGroup="step.fieldGroup" ref="stepComponentsRef" />
              </template>

              <template slot="actions" slot-scope="{ isValid }">
                <div>
                  <sc-button text="Voltar" @click="backStep()" theme="default" type="button"/>
                  <sc-button text="Próximo" @click="navigateNext()" theme="primary" type="button"/>
                </div>
              </template>
            </sc-form>

          </sc-step-item>

          <sc-step-item :label="'Contatos'" :step="steps.length+1" :clickable="false">
            <sc-contact />
          </sc-step-item>

          <sc-step-item :label="'Credenciais na Intelipost'" :step="steps.length+2" :clickable="false">
            <sc-show-credentials :step="steps.length+2" />
          </sc-step-item>

          <sc-step-item :label="'Concluído'" :step="steps.length+3" :clickable="false">
            <sc-finished />
          </sc-step-item>

        </sc-steps>
      </div>
    </div>
  </sc-page-base>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

import {
  ScPageBase,
  ScSteps,
  ScStepItem,
  ScForm,
  ScButton,
} from '@intelipost-js/secure-components';

import ScConfigWarehouses from './components/warehouse/ScConfigWarehouses.vue';
import ScConfig from './components/config/ScConfig.vue';
import ScContact from './components/ScContact.vue';
import ScShowCredentials from './components/ScShowCredentials.vue';
import ScFinished from './components/ScFinished.vue';
import ScCarrierCredentials from './components/credentials/ScCarrierCredentials';

const { mapState, mapActions, mapMutations } = createNamespacedHelpers('integrations/integrationsAppSelfService');

export default {
  name: 'integrations-app-self-service',
  components: {
    ScPageBase,
    ScSteps,
    ScStepItem,
    ScForm,
    ScButton,
    ScConfig,
    ScContact,
    ScShowCredentials,
    ScFinished,
    ScConfigWarehouses,
    ScCarrierCredentials,
  },
  data() {
    return {
      appDetails: null,
      steps: null,
    };
  },
  async created() {
    this.setLoading(true);
    const appId = this.$route.params.id;

    this.loadAppDetails(appId).then((appDetails) => {
      this.appDetails = appDetails;
      this.afterLoadAppDetails();
    });
  },
  computed: {
    ...mapState([
      'loading',
      'activeStep',
    ]),
  },
  methods: {
    ...mapActions([
      'loadAppDetails',
    ]),
    ...mapMutations([
      'backStep',
      'nextStep',
      'setLoading',
    ]),

    afterLoadAppDetails() {
      const steps = [];
      steps.push({
        title: 'Centro de distribuição',
        component: ScConfigWarehouses,
      });
      if (this.appDetails.credentials) {
        steps.push({
          title: 'Credenciais na Transportadora',
          component: ScCarrierCredentials,
          fieldGroupName: 'credentials',
          fieldGroup: this.appDetails.credentials,
        });
      }
      if (this.appDetails.config) {
        steps.push({
          title: 'Transportadora',
          component: ScConfig,
          fieldGroupName: 'config',
          fieldGroup: this.appDetails.config,
        });
      }
      this.steps = steps;
      this.setLoading(false);
    },
    navigateNext() {
      const stepComponent = this.$refs.stepComponentsRef[this.activeStep];

      if (stepComponent.validate && !stepComponent.validate()) {
        return;
      }
      this.nextStep();
    },
  },
  watch: {
    activeStep(newValue) {
      const stepComponent = this.$refs.stepComponentsRef[newValue];
      if (stepComponent && stepComponent.refresh) {
        stepComponent.refresh();
      }
    },
  },
};
</script>

<style lang='scss'>
@import "~@intelipost-js/secure-ui/src/scss/variables";

.img-client {
  height: 80px;
}

.margin-logo {
  margin-top: 10px;
}
</style>




// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/IntegrationsAppSelfService.vue